import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {MinimalUserModel} from '@core/api/data-access';
import {AvatarsComponent} from '@users/feature-users-avatars';

@Component({
	selector: 'dc-user-result-item', // Standard prefix 'dc'
	imports: [AvatarsComponent],
	templateUrl: './user-result-item.component.html', // Separate template
	styleUrls: ['./user-result-item.component.scss', '../result-item.shared.scss'], // Separate styles
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserResultItemComponent {
	// --- Inputs ---
	readonly item = input.required<MinimalUserModel>(); // Define the required 'item' input

	// --- Constructor ---
	constructor() {}

	// --- Lifecycle Hooks ---
	// ngOnInit(): void {}

	// --- Methods / Getters (Optional) ---

	/** Generates initials from the user's name */
	protected getInitials(): string {
		const name = this.item()?.displayName;
		if (!name) {
			return '?';
		}
		const parts = name.split(' ').filter(Boolean); // Split and remove empty parts
		if (parts.length === 0) {
			return '?';
		}
		if (parts.length === 1) {
			return parts[0].substring(0, 2).toUpperCase();
		}
		// Take first letter of first and last part
		return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
	}

	/** Generates a placeholder image URL */
	protected getPlaceholderImageUrl(): string {
		// Example: using via.placeholder.com with initials
		const initials = this.getInitials();
		const bgColor = this.stringToHslColor(this.item()?.id || 'default', 50, 60); // Generate color based on ID
		// Basic placeholder, replace color hash if needed
		return `https://via.placeholder.com/40/${bgColor.substring(1)}/ffffff?text=${initials}`;
	}

	// Helper to generate a somewhat consistent color based on a string (e.g., user ID)
	private stringToHslColor(str: string, s: number, l: number): string {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}
		const h = hash % 360;
		return `hsl(${h}, ${s}%, ${l}%)`;
	}
}
